"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnonymousSubject = exports.Subject = exports.SubjectSubscriber = void 0;

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Observable2 = require("./Observable");

var _Subscriber2 = require("./Subscriber");

var _Subscription = require("./Subscription");

var _ObjectUnsubscribedError = require("./util/ObjectUnsubscribedError");

var _SubjectSubscription = require("./SubjectSubscription");

var _rxSubscriber = require("./symbol/rxSubscriber");

/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(SubjectSubscriber, _Subscriber);

  function SubjectSubscriber(destination) {
    var _this;

    (0, _classCallCheck2.default)(this, SubjectSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SubjectSubscriber).call(this, destination));
    _this.destination = destination;
    return _this;
  }

  return SubjectSubscriber;
}(_Subscriber2.Subscriber);
/**
 * @class Subject<T>
 */


exports.SubjectSubscriber = SubjectSubscriber;

var Subject =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(Subject, _Observable);

  function Subject() {
    var _this2;

    (0, _classCallCheck2.default)(this, Subject);
    _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Subject).call(this));
    _this2.observers = [];
    _this2.closed = false;
    _this2.isStopped = false;
    _this2.hasError = false;
    _this2.thrownError = null;
    return _this2;
  }

  (0, _createClass2.default)(Subject, [{
    key: _rxSubscriber.rxSubscriber,
    value: function value() {
      return new SubjectSubscriber(this);
    }
  }, {
    key: "lift",
    value: function lift(operator) {
      var subject = new AnonymousSubject(this, this);
      subject.operator = operator;
      return subject;
    }
  }, {
    key: "next",
    value: function next(value) {
      if (this.closed) {
        throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
      }

      if (!this.isStopped) {
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();

        for (var i = 0; i < len; i++) {
          copy[i].next(value);
        }
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      if (this.closed) {
        throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
      }

      this.hasError = true;
      this.thrownError = err;
      this.isStopped = true;
      var observers = this.observers;
      var len = observers.length;
      var copy = observers.slice();

      for (var i = 0; i < len; i++) {
        copy[i].error(err);
      }

      this.observers.length = 0;
    }
  }, {
    key: "complete",
    value: function complete() {
      if (this.closed) {
        throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
      }

      this.isStopped = true;
      var observers = this.observers;
      var len = observers.length;
      var copy = observers.slice();

      for (var i = 0; i < len; i++) {
        copy[i].complete();
      }

      this.observers.length = 0;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.isStopped = true;
      this.closed = true;
      this.observers = null;
    }
  }, {
    key: "_trySubscribe",
    value: function _trySubscribe(subscriber) {
      if (this.closed) {
        throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
      } else {
        return (0, _get2.default)((0, _getPrototypeOf2.default)(Subject.prototype), "_trySubscribe", this).call(this, subscriber);
      }
    }
  }, {
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      if (this.closed) {
        throw new _ObjectUnsubscribedError.ObjectUnsubscribedError();
      } else if (this.hasError) {
        subscriber.error(this.thrownError);
        return _Subscription.Subscription.EMPTY;
      } else if (this.isStopped) {
        subscriber.complete();
        return _Subscription.Subscription.EMPTY;
      } else {
        this.observers.push(subscriber);
        return new _SubjectSubscription.SubjectSubscription(this, subscriber);
      }
    }
  }, {
    key: "asObservable",
    value: function asObservable() {
      var observable = new _Observable2.Observable();
      observable.source = this;
      return observable;
    }
  }]);
  return Subject;
}(_Observable2.Observable);

exports.Subject = Subject;

Subject.create = function (destination, source) {
  return new AnonymousSubject(destination, source);
};
/**
 * @class AnonymousSubject<T>
 */


var AnonymousSubject =
/*#__PURE__*/
function (_Subject) {
  (0, _inherits2.default)(AnonymousSubject, _Subject);

  function AnonymousSubject(destination, source) {
    var _this3;

    (0, _classCallCheck2.default)(this, AnonymousSubject);
    _this3 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AnonymousSubject).call(this));
    _this3.destination = destination;
    _this3.source = source;
    return _this3;
  }

  (0, _createClass2.default)(AnonymousSubject, [{
    key: "next",
    value: function next(value) {
      var destination = this.destination;

      if (destination && destination.next) {
        destination.next(value);
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      var destination = this.destination;

      if (destination && destination.error) {
        this.destination.error(err);
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      var destination = this.destination;

      if (destination && destination.complete) {
        this.destination.complete();
      }
    }
  }, {
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var source = this.source;

      if (source) {
        return this.source.subscribe(subscriber);
      } else {
        return _Subscription.Subscription.EMPTY;
      }
    }
  }]);
  return AnonymousSubject;
}(Subject);

exports.AnonymousSubject = AnonymousSubject;